module.exports.MOMENT_FORMAT_DATEANDTIME = "DD MMM YYYY h:mm A"
module.exports.MOMENT_FORMAT_DATE = "DD MMM YYYY"